<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select [(ngModel)]="filter.operator" class="form-control" (change)="filterChange.emit(filter)">
    <option value="in">est</option>
  </select>

  <div class="ml-2">
    <select [(ngModel)]="filter.tempValue" class="form-control" (ngModelChange)="filterChange.emit(filter)">
      <option [value]="[DELIVERY_STATUS.DELIVERED]">Livré</option>
      <option [value]="[DELIVERY_STATUS.INITIAL, DELIVERY_STATUS.PICKEDUP, DELIVERY_STATUS.INTRAVEL, DELIVERY_STATUS.IMMINENT_DELIVERY]">En cours de livraison</option>
      <option [value]="[DELIVERY_STATUS.PROBLEM, DELIVERY_STATUS.CANCELED]">Non livré</option>
    </select>
  </div>
</div>
